module.exports = __webpack_public_path__ + "img/BenefitsImage.239326d8.png";